import {
  Box,
  Flex,
  Icon,
  Text,
  Token,
  TransitionCollapse,
} from '@revolut-internal/ui-kit'
import { FC, PropsWithChildren, useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled(Box)`
  transition: ${Token.transition.background};
  background-color: ${props => (props.open ? Token.color.greyTone2 : undefined)};

  &:hover {
    background-color: ${Token.color.greyTone2};
  }

  & > [role='button'] {
    cursor: pointer;
  }
`

type Props = PropsWithChildren<{
  name: string
  initialOpen?: boolean
}>

export const CollapsibleSection: FC<Props> = props => {
  const { name, children, initialOpen = false } = props

  const [open, setOpen] = useState(initialOpen)

  return (
    <Wrapper open={open} px="s-8" borderRadius="16px" data-testid={name}>
      <Flex
        justifyContent="space-between"
        py="s-16"
        role="button"
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
      >
        <Text variant="h6" color="foreground">
          {name}
        </Text>
        <Icon name={open ? 'ChevronUp' : 'ChevronDown'} color="grey-tone-20" />
      </Flex>
      <TransitionCollapse in={open}>
        {open && <Box pb="s-8">{children}</Box>}
      </TransitionCollapse>
    </Wrapper>
  )
}
